import { isAxiosError } from "axios";
import { axios } from "../../utils/axios";
import { toastOptions } from "../../config/toast";
import { toast } from "react-toastify";
// import { toast } from "react-toastify";
// import { toastOptions } from "../../config/toast";

export const handlerOnSubmit = async (
  vari,
  setVari,
  data,
  setGenero,
  actions,
  setLoading,
  setNoContribuyente,
  setExistente,
  setCuposAgotados,
  setNoInfo,
  setDenegado,
  setError
) => {
  setLoading(true);
  const response = await axios().post("verificar_contribuyente", data);
  // console.log(response.status)
  // if(response.status == 500){
  //     console.log('entre')

  //     setLoading(false);
  //     return response.status
  // }
  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if ((data, !error)) {
      actions.guardarData(data);
      // toast.success("okey", toastOptions);
      setLoading(false);
      return response.status;
    }
    if ((!data, error)) {
      // setVari({ ...vari, loading: false, error: error });
      if (error === "Hay más de un resultado, debe especificar genero") {
        setGenero(true);
      }
      if (error === "Usuario no autorizado") {
        setNoContribuyente(true);
      }
      if (error === "Ya posee un registro") {
        setExistente(true);
      }

      if (error === "Ya no hay mas cupo.") {
        setCuposAgotados(1);
      }

      if (error.includes("No hay informaci")) {
        setNoInfo(true);
      }

      if (error === "Usuario perteneciente a planta política") {
        setDenegado(true);
      }

      if (error === "Hubo un error durante la consulta") {
        setError(true);
      }
      setVari({ ...vari, loading: false, error: error });

      // toast.error("No Okey",toastOptions);
      setLoading(false);
      return false;
    }
  } else {
    // toast.error("Hubo un error", toastOptions)
    setError("Hubo un error durante la consulta");
    setLoading(false);
    return false;
  }
};

export const reenviarEmail = async (payload, setLoadingReenviar) => {
  setLoadingReenviar(true);
  try {
    const response = await axios().post("reenviar_email_contribuyentes", payload);
    if (!isAxiosError(response)) {
      const {code ,data, error } = response.data;
      const { status } = response;
      if (status == 200) {
        toast.success("Se reenvio el email correctamente", toastOptions);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consultar", toastOptions);
    }
  } catch (error) {
    toast.error("Hubo un error, itentelo más tarde", toastOptions);
  } finally {
    setLoadingReenviar(false);
  }
};
